import {Component, inject, signal, ChangeDetectionStrategy} from "@angular/core"
import {injectTippyRef, TIPPY_REF} from "@ngneat/helipopper"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-support-tooltip",
    imports: [],
    templateUrl: "./material-support-tooltip.component.html",
    styleUrl: "./material-support-tooltip.component.scss",
})
export class MaterialSupportTooltipComponent {
    tippy = injectTippyRef()

    tippyRef = inject(TIPPY_REF)
    readonly $data = signal<{three: boolean; cycles: boolean}>(this.tippyRef.data)
}
